function get_browser() {
    var ua = navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []; 
    
    if (/trident/i.test(M[1])){
        tem=/\brv[ :]+(\d+)/g.exec(ua) || []; 
        return {
            name:'IE',version:(tem[1]||'')
        };
    }
    if (M[1] === 'Chrome'){
        tem = ua.match(/\bOPR|Edge\/(\d+)/)
        if (tem != null) {
            return {name:'Opera', version:tem[1]};
        }
    }
    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if ((tem=ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1,1,tem[1]);
    }
    return {
        name: M[0],
        version: M[1],
    };
}

var userAgentName = window.navigator.userAgent;
function isMobileSafari() {
    return userAgentName.match(/(iPod|iPhone|iPad|Macintosh)/) && navigator.userAgent.match(/AppleWebKit/)
}


var browser = get_browser();
var bp1 = 760;
var bp2 = 1000;
var bp3 = 1201;
var bp4 = 1280;

$(document).ready(function() {
    
    var logo = document.querySelector('#logo');
    logo.style.opacity = '1';
    
    if (browser.name == 'Safari' && browser.version == 15) {
        if (screen.width > bp1 && screen.width <= bp2) {
            logo.style.top = '-85px';
        }
        if (screen.width > bp2 && screen.width <= bp3) {
            logo.style.top = '-83px';
        }
        if (screen.width > bp3) {
            logo.style.top = '-83px';
        }
    }
});

window.addEventListener('resize', function(e){
    var logo = document.querySelector('#logo');

    if (browser.name == 'Safari' && browser.version == 15) {
        if (screen.width > bp1 && screen.width <= bp2) {
            logo.style.top = '-85px';
        }
        if (screen.width > bp2 && screen.width <= bp3) {
            logo.style.top = '-83px';
        }
        if (screen.width > bp3) {
            logo.style.top = '-83px';
        }
    }
});